<section class="container-section container-fluid g-0"
         [class.visible]="isVisible" [class.sticky]="sticky" #section>
    <ng-content/>
</section>
